import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { useParams, Link, useNavigate } from "react-router-dom";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_ALL_TEAMS_IN_TERM_QUERY } from "../../graphQL/team_term_qry";
import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";
import { TEAM_TERM_ALL_PERIODS_QUERY } from "../../graphQL/team_term_period_qry";
import { GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY } from "../../graphQL/team_term_member_qry";
import { 
  MEMBER_TERM_EVENT_ATTENDANCE,
  EDIT_TEAM_TERM_MEMBER_ATTENDANCE_MUTATION
} from "../../graphQL/member";

import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Tooltip,
  Button,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import Header from "../terms/Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },  
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },  
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  selectStyle: {
    minWidth: 350,
    height: 35,
    //  paddingLeft: 16,
    marginBottom: 10,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  }, 
  attendSelectStyle: {
    minWidth: 45,
    height: 35,
    //  paddingLeft: 16,
    marginBottom: 10,
  },
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#0D47A1",
    },
  },
}));

function TeamsResourcesAttandance() {
  const classes = useStyles();
  const { termUuid } = useParams();
  const [termName, setTermName] = useState("");
  const [termLink, setTermLink] = useState(null);
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [rows, setRows] = useState([]);
  const [initialRows, setInitialRows] = useState([]);
  const [termInfo, setTermInfo] = useState({});
  const [teamsList, setTeamsList] = useState([]);
  const [selectedTeamTermId, setSelectedTeamTermId] = useState(null);
  const [initialTeamTermId, setInitialTeamTermId] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [initialEventId, setInitialEventId] = useState(null);
  const [teamTermActivityData, setTeamTermActivityData] = useState([]);
  const [members, setMembers] = useState([]);
  const [staff, setStaff] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);

  const [getAllTermTeams] = useManualQuery(GET_ALL_TEAMS_IN_TERM_QUERY);
  const [getTermInfo] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID);
  const [getAllTeamTermPeriods] = useManualQuery(TEAM_TERM_ALL_PERIODS_QUERY);
  const [getAllTeamTermResources] = useManualQuery(GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY);
  const [getMemberTermEventAttendanceQuery] = useManualQuery(
    MEMBER_TERM_EVENT_ATTENDANCE
  );
  const [editTeamTermResourceAttendance] = useMutation(
    EDIT_TEAM_TERM_MEMBER_ATTENDANCE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []); 

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
    }
    return newFormat;
  };   

  useEffect(() => {
    (() => getTermData())();
  }, [termUuid]);  

  useEffect(() => {
    (() => getTeamsList())();
  }, [termInfo]);

  useEffect(() => {
    (() => getAttendanceData())();
  }, [selectedTeamTermId]);

  useEffect(() => {
    (() => getResourcesData())();
  }, [selectedEventId]);


  const getTermData = async () => {
    if (termUuid){      
      // Get term information
      const {
        loading: termInfoLoading,
        error: termInfoError,
        data: termInfo,
      } = await getTermInfo({
        variables: { termUuid: termUuid },
      });

      if (!termInfoLoading && termInfo && termInfo.getTermDataByTermUuid) {
        setTermInfo(termInfo.getTermDataByTermUuid);
        setTermName(termInfo.getTermDataByTermUuid.name);
        setTermLink(`${project_url}/terms/${termUuid}`);
      }
      if (
        termInfoError &&
        termInfoError.graphQLErrors &&
        termInfoError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }

      if (
        termInfoError &&
        termInfoError.graphQLErrors &&
        termInfoError.graphQLErrors[0].message === "Term matching query does not exist."
      ) 
      {
        alert('Are you sure you have valid URL?');
      }           
    }
    else
    {
      alert('Are you sure you have valid URL?');
    }
  };

  const getTeamsList = async () => {
    if (termInfo.termId) {
      const {
        loading: teamsListLoading,
        error: teamsListError,
        data: teamsListData,
      } = await getAllTermTeams({
        variables: {
          termId: parseInt(termInfo.termId),
        },
      });
      if (!teamsListLoading && 
          teamsListData && 
          teamsListData.getAllTeamsInTerm) {
        setTeamsList(teamsListData.getAllTeamsInTerm);
        teamsListData.getAllTeamsInTerm[0] && 
        setSelectedTeamTermId(
          teamsListData.getAllTeamsInTerm[0].teamTermId
        );
        teamsListData.getAllTeamsInTerm[0] && 
        setInitialTeamTermId(
          teamsListData.getAllTeamsInTerm[0].teamTermId
        );
      };
    };
  };

  const getAttendanceData = async() => {
    if (selectedTeamTermId){
      const {
        loading: teamTermPeriodsLoading,
        error: teamTermPeriodsError,
        data: teamTermPeriodsData,
      } = await getAllTeamTermPeriods({
        variables: {
          teamTermId: parseInt(selectedTeamTermId),
        },
      });

      if (
        !teamTermPeriodsLoading &&
        teamTermPeriodsData &&
        teamTermPeriodsData.teamTermAllPeriodList
      ) {
        setTeamTermActivityData(flattenRows(
          teamTermPeriodsData.teamTermAllPeriodList)
        );
        if (flattenRows(teamTermPeriodsData.teamTermAllPeriodList) &&
          flattenRows(teamTermPeriodsData.teamTermAllPeriodList)[0]){
          setSelectedEventId(flattenRows(
          teamTermPeriodsData.teamTermAllPeriodList)[0].teamTermEventId);
          setInitialEventId(flattenRows(
          teamTermPeriodsData.teamTermAllPeriodList)[0].teamTermEventId);
        };
      };      
    };    
  };

  const getResourcesData = async() => {
    if (selectedTeamTermId){
      const {
        loading: teamTermResourcesLoading,
        error: teamTermResourcesError,
        data: teamTermResourcesData,
      } = await getAllTeamTermResources({
        variables: {
          teamTermId: parseInt(selectedTeamTermId),
        },
      });

      if (!teamTermResourcesLoading &&
          teamTermResourcesData &&
          teamTermResourcesData.getAllMembersInTeamTerm) {
        let memberList = 
          teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Member");
        for (const member of memberList) {
          if (selectedEventId && member.teamTermMemberId) {
            const {
              loading: loadingAttendanceData,
              error: errorAttendanceData,
              data: attendanceData,
            } = await getMemberTermEventAttendanceQuery({
              variables: {
                teamTermMemberId: parseInt(member.teamTermMemberId),
                teamTermEventId: parseInt(selectedEventId),
              },
            });
          
            if (!loadingAttendanceData && 
              attendanceData &&
              attendanceData.getMemberTermEventAttendance) {
              member["attended"] = 
                attendanceData.getMemberTermEventAttendance.attended
                ? attendanceData.getMemberTermEventAttendance.attended
                : false;
              member["teamTermResourceAttendanceId"] = 
                attendanceData.getMemberTermEventAttendance.teamTermResourceAttendanceId;
            }
            if (errorAttendanceData) {
              member["attended"] = false;
              if (errorAttendanceData.graphQLErrors[0].message === "Signature has expired")
                navigate(`${project_url}/signin/?next=${pathname}`);
            }                      
          };
        };
        setMembers(memberList);

        let staffList = 
          teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Staff");
        for (const stff of staffList) {
          if (selectedEventId && stff.teamTermMemberId) {
            const {
              loading: loadingAttendanceData,
              error: errorAttendanceData,
              data: attendanceData,
            } = await getMemberTermEventAttendanceQuery({
              variables: {
                teamTermMemberId: parseInt(stff.teamTermMemberId),
                teamTermEventId: parseInt(selectedEventId),
              },
            });
          
            if (!loadingAttendanceData && 
              attendanceData &&
              attendanceData.getMemberTermEventAttendance) {
              stff["attended"] = 
                attendanceData.getMemberTermEventAttendance.attended
                ? attendanceData.getMemberTermEventAttendance.attended
                : false;
              stff["teamTermResourceAttendanceId"] = 
                attendanceData.getMemberTermEventAttendance.teamTermResourceAttendanceId;
            }
            if (errorAttendanceData) {
              stff["attended"] = false;
              if (errorAttendanceData.graphQLErrors[0].message === "Signature has expired")
                navigate(`${project_url}/signin/?next=${pathname}`);
            }                     
          };
        };
        setStaff(staffList);       
      };
    };
  };

  const handleTeamChange = e => {
    setSelectedTeamTermId(e.target.value);
  };
  
  const handleEventChange = event => {
    setSelectedEventId(event.target.value);
  };

  const handleAttendedChange = (event, row) => {
    const chgRow = findAnd.changeProps(
      rows,
      { teamTermResourceAttendanceId: row.teamTermResourceAttendanceId },
      { attended: event.target.value }
    );
    setRows(chgRow);    
  };

  const handleSave = async() => {
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].teamTermResourceAttendanceId){
        const {
          loading: loadEditTeamTermResourceAttendance,
          error: errorEditTeamTermResourceAttendance,
          data: dataEditTeamTermResourceAttendance,
        } = await editTeamTermResourceAttendance({
          variables: {
            teamTermResourceAttendanceId: 
            parseInt(rows[i].teamTermResourceAttendanceId),
            attended:JSON.parse(rows[i].attended),
          },
        });
        if (errorEditTeamTermResourceAttendance) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
        else if (dataEditTeamTermResourceAttendance && 
          dataEditTeamTermResourceAttendance.editTeamTermMemberAttendance) 
        {         
          setAlertMsg({
            title: "Save Teams Resources Attendance",
            msg: "Resources attendance is updated in team: “" +
            teamsList.find(
              team => parseInt(team.teamTermId) === 
              parseInt(selectedTeamTermId)).teamId.name + 
            "” in term: “" + termInfo.name + 
            "” for event: “" + teamTermActivityData.find(
              event => parseInt(event.teamTermEventId) === 
              parseInt(selectedEventId)).event + "”.", 
          });
        };
      };
    };
  };

  const handleCancel = () => {
    // setSelectedTeamTermId(initialTeamTermId);
    // setSelectedEventId(initialEventId);
    setRows(initialRows);
  };

  useEffect(() => {
    let rows = [];
    //first row with col span
    rows.push({
      index: 0,
      name: "",
      role: "",
      attended: "",
      teamTermResourceAttendanceId: "", 
    });
    
    for (var i = 0; i < members.length; i++) {
      let row = [];
      row["index"] = i + 1;
      row["name"] = members[i].userId.firstName + ' ' + members[i].userId.lastName;
      row["role"] = members[i].roleId.roleName;
      row["attended"] = members[i].attended;
      row["teamTermResourceAttendanceId"] = members[i].teamTermResourceAttendanceId;
      rows.push({
        index: row.index,
        name: row.name,
        role: row.role,
        attended: row.attended,
        teamTermResourceAttendanceId: row.teamTermResourceAttendanceId,       
      });      
    };

    // row for staff label with col span
    rows.push({
      index: members.length + 1,
      name: "",
      role: "",
      attended: "",
      teamTermResourceAttendanceId: "",
    });

    for (var j = 0; j < staff.length; j++) {
      let row = [];
      row["index"] = j + members.length + 2;
      row["name"] = staff[j].userId.firstName + ' ' + staff[j].userId.lastName;
      row["role"] = staff[j].roleId.roleName;
      row["attended"] = staff[j].attended;
      row["teamTermResourceAttendanceId"] = staff[j].teamTermResourceAttendanceId;
      rows.push({
        index: row.index,
        name: row.name,
        role: row.role,
        attended: row.attended,
        teamTermResourceAttendanceId: row.teamTermResourceAttendanceId,        
      });      
    };
    if (members.length || staff.length){
      setInitialRows(rows);  
      setRows(rows);
    }
    else
    {
      setInitialRows([]);  
      setRows([]);
    };
  }, [members, staff]);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      minWidth: 80,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) {
          return 4;
        }
        if (row.index === members.length + 1) {
          return 4;
        }
        return undefined;
      },
      renderCell: (rows) => {        
        if (rows.row.index === 0) {
          if (members.length){
            return (
              <>
                <Typography
                  style={{ 
                    paddingRight: 5, 
                    paddingBottom: 2,
                    paddingTop: 15,
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                  variant="h2"
                >
                  Members
                </Typography>
              </>
            );
          }
          else
          {
            return (
              <>
                <Box
                  mt={0.5}
                  mb={1}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                  }}
                >
                <Typography
                  style={{ 
                    fontSize: 16,
                    fontWeight: 700,
                    paddingBottom: 2,
                  }}
                  variant="h2"
                >
                  Members
                </Typography>
                <Typography
                  style={{ 
                    paddingTop: 2,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  variant="h2"
                >
                  No member is assigned to this team.
                </Typography>
                </Box>
              </>
            );
          }
        }
        else if (rows.row.index === members.length + 1) {
          if (staff.length){
            return (
              <>
                <Typography
                  style={{ 
                    paddingRight: 5, 
                    paddingBottom: 2,
                    paddingTop: 15,
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                  variant="h2"
                >
                  Staff
                </Typography>
              </>
            );
          }
          else
          {
            return (
              <>
                <Box
                  mt={0.5}
                  mb={1}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                  }}
                >
                <Typography
                  style={{ 
                    fontSize: 16,
                    fontWeight: 700,
                    paddingBottom: 2,
                  }}
                  variant="h2"
                >
                  Staff
                </Typography>
                <Typography
                  style={{ 
                    paddingTop: 2,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  variant="h2"
                >
                  No staff is assigned to this team.
                </Typography>
                </Box>
              </>
            );
          }
        };
      },
    },
    {
      field: "role",
      headerName: "Role",
      headerClassName: "super-app-theme--header",
      minWidth: 50,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "attended",
      headerName: "Attended? ",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (rows) => (
        <Select
          className={classes.attendSelectStyle}
          value={rows.value}
          margin="normal"
          onChange={(e) => {
            handleAttendedChange(e, rows.row);
          }}
        >              
          <MenuItem value="true">Yes</MenuItem>
          <MenuItem value="false">No</MenuItem>               
        </Select>
      ),
    },    
  ];  

  const flattenRows = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          if (event.attendanceRequired) {
            eventRows.push({
              id: rowId++,
              teamTermPeriodId: period.teamTermPeriodId,
              period: period.name,
              startDate: period.startDate,
              endDate: period.endDate,
              event: event.name,
              desc: event.desc,
              eventType: event.eventType,
              teamTermEventId: event.teamTermEventId,
              desc: event.desc,
              scheduledDate: event.scheduledDate,
              actualDate: event.actualDate,
              attendanceRequired: event.attendanceRequired,
            });
          };
        });
      }
    });
    return eventRows;
  }; 

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid item  style={{ textAlign: "center" }}>
            <Typography
              variant="h1"
              style={{ 
                marginBottom: 10, 
                fontSize: 20,
                marginTop: 10 
              }}
            >
              Teams Resources Attendance
            </Typography>
          </Grid>
          <Box
            sx={{
              height: '1px',
              backgroundColor: '#ccc',
              width: '100%',
              marginTop: 2,
              position: 'relative',
              zIndex: 1,
            }}
          />
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
              paddingLeft: 25,
              paddingBottom: 10,
            }}
          >
            <Typography style={{ paddingRight: 20 }} variant="h2">
              Term:
            </Typography>
            {termInfo && termInfo.startDate && termInfo.endDate &&
              (
                <Typography variant="h3">
                  {termInfo.name} ({dayFormat(termInfo.startDate.substring(0, 10), "monthDDYYYY")} - {dayFormat(termInfo.endDate.substring(0, 10), "monthDDYYYY")})
                </Typography>
              )
            }
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
              paddingLeft: 25,
              paddingBottom: 5,
            }}
          >
            <Typography
              variant="h3"
              style={{
                fontSize: 16,
                textAlign: "left",
                paddingTop: 5,
                paddingRight: 3,
              }}
            >
              <b>Teams:</b>
            </Typography>
            <Box pl={1}>
              <Select
                className={classes.selectStyle}
                value={selectedTeamTermId 
                      ? selectedTeamTermId 
                      : teamsList[0] 
                        ? teamsList[0].teamTermId
                        : ""
                      }
                margin="normal"
                onChange={handleTeamChange}
              >              
                {teamsList.map((team, index) => (
                  <MenuItem key={index} value={team.teamTermId}>
                    {team.teamId.name}
                  </MenuItem>
                ))}                
              </Select>
            </Box>            
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
              paddingLeft: 25,
              paddingBottom: 10,
            }}
          >
            <Typography
              variant="h3"
              style={{
                fontSize: 16,
                textAlign: "left",
                paddingTop: 5,
              }}
            >
              <b>Events:</b>
            </Typography>
            <Box pl={1}>
              <Select
                className={classes.selectStyle}
                value={selectedEventId 
                      ? selectedEventId 
                      : teamTermActivityData[0] 
                        ? teamTermActivityData[0].teamTermEventId
                        : ""
                      }
                margin="normal"
                onChange={handleEventChange}
              >              
                {teamTermActivityData.map((event, index) => (
                  <MenuItem key={index} value={event.teamTermEventId}>
                    {event.event}
                  </MenuItem>
                ))}                
              </Select>              
            </Box>            
          </Box>
          <Box
            sx={{
              borderBottom: '2px solid #ccc',
              width: '100%',
              marginTop: 2,
            }}
          />
        </Grid>
      </>
    );
  } 

  if (loadContent)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: termName, link: termLink },
            { label: "Teams Resources Attendance", link: null },
          ]}
        />
        <div className={classes.container}>                   
          <Box >
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              hideFooter={true}
              autoWidth={true}
              autoHeight={true}
              getRowId={(row) => row.index}
              
              getCellClassName={(rows) => {
                if (rows.row.index === 0) return "colSpan";
                if (rows.row.index === members.length + 1) return "colSpan";
              }}
              experimentalFeatures={{ newEditingApi: true }}              
              slots={{
                toolbar: DataGridTitle,
                noRowsOverlay: () => (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    No member or staff is assigned to this team.
                  </div>
                ),
              }}
            />
          </Box>
          <Grid
            container
            spacing={3}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              padding: "24px",
              paddingTop: "25px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 12 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}                      
              onClick={handleCancel}
            >
              Cancel 
            </Button> 
          </Grid>        
        </div>
        {alertMsg.msg && !alertMsg.type && (
          <AlertDialog
            title={alertMsg.title}
            contentMsg={alertMsg.msg}
            closeDialog={() => {
              setAlertMsg([]);
            }}
          />
        )}        
      </div>
    );
  else return;
}

export default TeamsResourcesAttandance;
